import { render, staticRenderFns } from "./MakeItem.vue?vue&type=template&id=cff94744&scoped=true&"
import script from "./MakeItem.vue?vue&type=script&lang=js&"
export * from "./MakeItem.vue?vue&type=script&lang=js&"
import style0 from "./MakeItem.vue?vue&type=style&index=0&id=cff94744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff94744",
  null
  
)

export default component.exports